import type { Key } from 'react';
import { z } from 'zod';
import type { PartialUndefinedOrNull } from '@/types/partial';
import { NotNullStringSchema } from '@/std/schema';

export const EmailSchema = z.object({
    ema_comercial: z.union([z.literal(0), z.literal(1)]),
    ema_descricao: NotNullStringSchema,
    ema_documentos_fiscais: z.union([z.literal(0), z.literal(1)]),
    ema_email: z.string(),
    ema_empresa_idpk: z.number(),
    ema_financeiro: z.union([z.literal(0), z.literal(1)]),
    ema_geral: z.union([z.literal(0), z.literal(1)]),
    ema_idpk: z.number(),
    ema_pessoa_idpk: z.number(),
    ema_principal: z.union([z.literal(0), z.literal(1)]),
    ema_ultima_alteracao: z.union([z.string(), z.null()]),
});

export type Email = z.infer<typeof EmailSchema>;

export type EmailBody = PartialUndefinedOrNull<Email> & {
    key: Key;
    excluir?: 'S';
};
